import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Grow } from "@mui/material";

// interface CardProps {
//   imgSrc?: string;
//   title: string;
//   subTitle: string;
//   body: string;
//   objectFit?: string;
//   borderColor?: string;
// }

// const ContentCards: React.FC<CardProps> = ({
const ContentCards = ({
  imgSrc,
  title,
  subTitle,
  email,
  body,
  objectFit,
  borderColor,
  isHomePage,
  imageHeight = 160
}) => {
  return (
    <Grow in={true}>
      <Card
        sx={{
          boxShadow:
            borderColor?.length && borderColor != "none"
              ? "3px 3px 10px rgba(84,77,160,0.3) !important"
              : "4px 3px 2px #efefef !important",
          background: "rgba(84,77,160,0.05)",
          // borderRadius: "24px",
          border: "1px solid #efefef",
          ...(isHomePage && { height: "80px" }),
          // height: "80px",
          marginBottom: borderColor?.length && borderColor != "none" ? "1rem" : "0.4rem",
          borderColor: borderColor,
          transition:
            borderColor?.length && borderColor != "none"
              ? "transform 0.15s ease-in-out"
              : "",
          transform:
            borderColor?.length && borderColor != "none"
              ? "scale3d(1.04, 1.04, 1)"
              : "",
        }}
      >
        {imgSrc?.length ?
          <CardMedia
            component="img"
            alt="green iguana"
            height="160"
            //     height="80"
            image={imgSrc}
            // MT added
            objectFit="contain" // Default value assigned here
            sx={{
              objectFit: objectFit ? objectFit : "cover",
              height: imageHeight,
            }}
          /> : null}
        <CardContent>
          <Typography color="primary" variant="h3" mb={0.5} fontWeight={"bold"}>
            {title}
          </Typography>
          <Typography
            variant="body1"
            color="text.primary"
            mb={1}
            component={"div"}
            //          background= "rgba(84,77,160,0.1)"
            fontWeight={"bold"}
            dangerouslySetInnerHTML={{ __html: subTitle }}
          ></Typography>
          <Typography
//            variant="body1"
            variant="h2"
            color="rgba(221, 110, 16, .8)"
            align="center"
            mb={1}
            component={"div"}
            //          background= "rgba(84,77,160,0.1)"
            fontWeight={"bold"}
            dangerouslySetInnerHTML={{ __html: email }}
          ></Typography>
          <Typography
            component={"div"}
            color="grey.600"
            dangerouslySetInnerHTML={{ __html: body }}
          ></Typography>
        </CardContent>
      </Card>
    </Grow>
  );
};

export default ContentCards;